import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sheetConfigInitialState } from './sheetConfig.initialState';

const sheetConfigSlice = createSlice({
  name: 'sheetConfig',
  initialState: sheetConfigInitialState,
  reducers: {
    setSheetConfig: (state, action) => {
      state.sheetConfig = action.payload;
    },
    setActiveSheetName: (state, action) => {
      state.activeSheetName = action.payload;
    },
    setFileTitle: (state, action: PayloadAction<any>) => {
      if (!state.data.fileTitle) {
        state.data.fileTitle = [];
      }

      if (action.payload.fileTitle && Array.isArray(action.payload.fileTitle)) {
        const newFileTitle = action.payload.fileTitle[0];
        const existingIndex = state.data.fileTitle.findIndex(
          (item) => item.sheetName === newFileTitle.sheetName
        );

        if (existingIndex !== -1) {
          state.data.fileTitle[existingIndex] = newFileTitle;
        } else {
          state.data.fileTitle.push(newFileTitle);
        }
      } else {
        const existingIndex = state.data.fileTitle.findIndex(
          (item) => item.sheetName === action.payload.sheetName
        );

        if (existingIndex !== -1) {
          state.data.fileTitle[existingIndex] = action.payload;
        } else {
          state.data.fileTitle.push(action.payload);
        }
      }
    },
    // this will return initial state of fileTitle
    clearFileTitle: (state) => {
      state.data.fileTitle = sheetConfigInitialState.data.fileTitle;
    },
    // this will update the fileTitle sheetName
    updateFileTitleSheetName: (
      state,
      action: PayloadAction<{
        prevSheetName: string;
        newSheetName: string;
      }>
    ) => {
      state.data.fileTitle = state.data.fileTitle.map((item) => {
        if (item.sheetName === action.payload.prevSheetName && item.fileId) {
          return { ...item, sheetName: action.payload.newSheetName };
        }
        return item;
      });
    },
  },
  extraReducers: (builder) => {},
});

export const {
  setSheetConfig,
  setActiveSheetName,
  setFileTitle,
  clearFileTitle,
  updateFileTitleSheetName,
} = sheetConfigSlice.actions;
export default sheetConfigSlice.reducer;
